<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Log in to your Account Below
              </h2>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <form v-on:submit.prevent="login">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="username">Username</span>
                    </div>
                    <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="username" v-model="username" @change="resetInvalidCredentials">
                  </div>
                  
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="password">Password</span>
                    </div>
                    <input type="password" class="form-control" placeholder="Password" aria-label="Password" aria-describedby="password" v-model="password" @change="resetInvalidCredentials">
                  </div>
                  
                  <div><button class="btn btn-primary">Log In</button></div>
                  
                  <p v-show="invalidCredentials">Invalid Username/Password</p>
                </form>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import WebLLCRESTApi from "../api/api";
  
  export default {
    data() {
      return {
        username: "",
        password: "",
        invalidCredentials: false
      };
    },
    
    methods: {
      resetInvalidCredentials() {
        this.invalidCredentials = false;
      },
      
      async login() {
        var api = new WebLLCRESTApi("Clients");
        
        var token = await api.login(this.username, this.password);
        
        if(token) {
          this.$router.push("/");
        }
        else {
          this.invalidCredentials = true;
        }
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LogIn.vue